import { render, staticRenderFns } from "./ContactDataDialog.vue?vue&type=template&id=1e72c0c8&"
import script from "./ContactDataDialog.vue?vue&type=script&lang=js&"
export * from "./ContactDataDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports